export default __webpack_public_path__ + "static/flag-ie-820ee9d0b04206fd5408232e9ac4a689.svg";